import React from 'react';
import PropTypes from 'prop-types';
import { Metric } from '@opendate-app/setlist';
import { formatAmount } from './dealStages';

const metricGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
  gap: 'var(--setlist-spacing-xl)',
};

export function countLabel(count, labels) {
  const noun = Number(count) === 1 ? labels.deal.singular : labels.deal.plural;
  return `${Number(count || 0).toLocaleString()} ${noun.toLowerCase()}`;
}

function DealsPipelineSummary({ totals, labels, loading = false }) {
  if (!totals) return null;

  const withoutProbability = totals.without_probability_count || 0;
  const tiles = [
    {
      label: `Open ${labels.deal.plural.toLowerCase()}`,
      value: formatAmount(Number(totals.open_amount || 0)),
      hint: `${countLabel(totals.open_count, labels)} open`,
    },
    {
      label: 'Weighted pipeline',
      value: formatAmount(Number(totals.weighted_amount || 0)),
      hint: withoutProbability > 0
        ? `${countLabel(withoutProbability, labels)} without a probability`
        : 'Amount × probability',
    },
    {
      label: `Due in ${totals.due_soon_days || 30} days`,
      value: formatAmount(Number(totals.due_soon_amount || 0)),
      hint: `${countLabel(totals.due_soon_count, labels)} closing soon`,
    },
  ];

  return (
    <div style={{ ...metricGrid, opacity: loading ? 0.5 : 1 }} aria-busy={loading} data-testid="deals-pipeline-summary">
      {tiles.map((tile) => (
        <Metric key={tile.label} label={tile.label} value={tile.value} change={{ label: tile.hint }} />
      ))}
    </div>
  );
}

DealsPipelineSummary.propTypes = {
  totals: PropTypes.object,
  labels: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

export default DealsPipelineSummary;
